import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { AccountHistoryComponent } from '../account-history/account-history.component';
import { AppointmentsListComponent } from '../appointments-list/appointments-list.component';
import { InsuranceInformationComponent } from '../insurance-information/insurance-information.component';
import { PrescriptionsComponent } from '../prescriptions/prescriptions.component';
import { ProcedureHistoryComponent } from '../procedure-history/procedure-history.component';
import { TreatmentPlansComponent } from '../treatment-plans/treatment-plans.component';
import { PatientMainComponent } from "../patient-main/patient-main.component";
import { PatientSummaryComponent } from "../patient-summary/patient-summary.component";
import { ClinicInfoComponent } from '../clinic-info/clinic-info.component';

@Component({
  selector: 'app-patient-dashboard-main',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AccountHistoryComponent,
    ProcedureHistoryComponent,
    TreatmentPlansComponent,
    PrescriptionsComponent,
    AppointmentsListComponent,
    InsuranceInformationComponent,
    PatientMainComponent,
    PatientSummaryComponent,
    ClinicInfoComponent
],
  templateUrl: './patient-dashboard-main.component.html',
  styleUrls: ['./patient-dashboard-main.component.scss']
})
export class PatientDashboardMainComponent {
  selectedIndex = 0;

  onTabChange(event: any): void {
    this.selectedIndex = event.index;
  }
}
